import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=565efc9c&scoped=true"
import script from "./Introduce.vue?vue&type=script&scope=true&lang=js"
export * from "./Introduce.vue?vue&type=script&scope=true&lang=js"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=565efc9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565efc9c",
  null
  
)

export default component.exports